const handleMouse = require('./mouseDrag').default;
const questions = require('./questions').default;
const partner = require('./partner');
const news = require('./news');
const homepage = () => {
    if ($(".homepage").length) {
        questions();
        handleMouse();
        services();
        partner();
        news();
    }
}

const services = () => {
    const $slider = $(".services-list .slide")
    $slider.slick({
        speed: 500,
        arrows: true,
        dots: true,
        nextArrow: $(".services-list").find(".next"),
        prevArrow: $(".services-list").find(".prev"),
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    autoplay: false,
                    arrows: false,
                    dots: false
                }
            },
        ]
    }).on("init", function(){
        aos.refresh(); //tính toán lại tọa độ các animation
    })
}





module.exports = homepage